var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "point-card"
  }, [_c('div', {
    staticClass: "point-card__image",
    class: {
      'point-card__image--empty': !_vm.item.image
    }
  }, [_vm.item.image ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.item.image
    }
  }) : _vm._e(), _vm.showPreviewButton ? _c('button', {
    staticClass: "point-card__preview-btn",
    on: {
      "click": _vm.handlePreview
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
    }
  })])]) : _vm._e()]), _c('div', {
    staticClass: "point-card__content"
  }, [_vm.item.start_at || _vm.item.end_at ? _c('div', {
    staticClass: "point-card__date"
  }, [_vm._v(_vm._s(_vm.formattedDate(_vm.item.start_at)) + " ~ " + _vm._s(_vm.formattedDate(_vm.item.end_at)))]) : _c('div', {
    staticClass: "point-card__date"
  }, [_vm._v(_vm._s(_vm.item.date || ''))]), _c('div', {
    staticClass: "point-card__title"
  }, [_vm._v(_vm._s(_vm.item.name))]), _c('div', {
    staticClass: "point-card__bottom s-flex s-items-center s-justify-between"
  }, [_vm.noPoint ? _c('div', {
    staticClass: "point-card__free"
  }, [_vm._v("無法兌換")]) : !_vm.item.point ? _c('div', {
    staticClass: "point-card__free"
  }, [_vm._v("免費領取")]) : _c('div', {
    staticClass: "point-card__point"
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "r": "10",
      "fill": "currentcolor"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.91 5.718V15H8.431V11.438H10.732C12.994 11.438 14.125 10.476 14.125 8.565C14.125 6.667 12.994 5.718 10.758 5.718H6.91ZM8.431 7.018H10.641C11.304 7.018 11.798 7.135 12.11 7.382C12.422 7.616 12.591 8.006 12.591 8.565C12.591 9.124 12.435 9.527 12.123 9.774C11.811 10.008 11.317 10.138 10.641 10.138H8.431V7.018Z",
      "fill": "white"
    }
  })]), _vm._v(" " + _vm._s(_vm.item.point.toLocaleString()) + " ")]), _vm.isRedeemed ? _c('div', {
    staticClass: "point-card__redeemed"
  }, [_c('img', {
    attrs: {
      "src": require("@/pages/Dashboard/Point/stamp-redeemed.png")
    }
  })]) : _c('div', {
    staticClass: "point-card__button"
  }, [_vm.isNotYetExchangeable ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v(" 尚未開放 ")]) : _vm.isExpired ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_vm._v(" 已過期 ")]) : _vm.noPoint ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" 無法兌換 ")]) : _vm.item.quantity <= 0 ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" 已兌換完畢 ")]) : _vm.item.point > _vm.availablePoints ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-xs btn-not-enough",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" 點數不足 ")]) : _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-xs btn-exchange",
    attrs: {
      "type": "button",
      "disabled": _vm.item.point === null
    },
    on: {
      "click": function click($event) {
        return _vm.handleExchange(_vm.item);
      }
    }
  }, [_vm._v(" 兌換 ")])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }